const reservedPathSegments = ['404', '503'];

export const parseDashboardIdFromPath = (pathname: string): string | null => {
  const firstSegment = pathname.split('/')[1];

  if (!firstSegment || reservedPathSegments.includes(firstSegment)) {
    return null;
  }

  return firstSegment;
};
